// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notes-area {
  border: 1px solid #EBE9EB;
  border-radius: 3px;
  background-color: #FCFCFC;
  width: 100%;
  height: 160px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/interview-details/interview-details.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;AACJ","sourcesContent":[".notes-area {\n    border: 1px solid #EBE9EB;\n    border-radius: 3px;\n    background-color: #FCFCFC;\n    width: 100%;\n    height: 160px;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
